/**
 * @description Type of form field, e.g. text, number, checkbox.
 */
// Two type files in solution: src/providers/formbuilder/input-type.ts
export enum InputType {
  Text = 'Text',
  Number = 'Number',
  OptionList = 'OptionList',
  CheckBox = 'CheckBox',
  Date = 'Date',
  Hidden = 'Hidden',
  Password = 'Password',
  Tel = 'Tel',
  Toggle = 'Toggle',
  Loqate = "loqate",
}


// WEBPACK FOOTER //
// ./src/model/types/input-type.ts